var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraTakePicture = function SvgCameraTakePicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-297 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 61",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(297 542)",
    fill: "#f9db41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9774"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 24",
    transform: "translate(307 552)",
    fill: "none",
    stroke: "#ed1f24",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(311 556)",
    fill: "#ed1f24"
  })))));
};
export default SvgCameraTakePicture;